<template>
	<div class="content">
		<LayoutBanner />

		<div class="news min_cw">
			<h2 class="title">新闻动态</h2>

			<ul v-loading="loading" class="news_list">
				<li v-for="(item, index) in list" :key="index" @click="itemClick(item, index)">
					<div class="left">
						<img class="img" :src="item.news_pic ? $http.fileUrl + item.news_pic : require('@/assets/news_default.jpg')" alt="">
					</div>
					<div class="right">
						<div class="top">
							<h3 class="title">{{ item.news_title }}</h3>
							<p class="text">{{ item.remark }}</p>
						</div>
						<div class="bottom">{{ $formatDate(item.create_time, "date") }}</div>
					</div>
				</li>
			</ul>

			<el-pagination
					v-if="total > 0"
					background
					layout="prev, pager, next"
					class="page"
					:total="total"
					:current-page.sync="queryParams.pageNum"
					:page-size="queryParams.pageSize"
					@current-change="getList"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import LayoutBanner from '@/components/Layout/banner'
import {getNewsListApi} from "@/api";

export default {
	name: "index",
	components: {
		LayoutBanner,
	},
	data() {
		return {
			loading: false,
			queryParams: {
				// orderContent: "create_time desc",
				pageNum: 1,
				pageSize: 10,
			},
			total: 0,
			list: [],
		}
	},
	created() {
		this.getList();
	},
	methods: {
		async getList() {
			this.loading = true;
			const res = await getNewsListApi(this.queryParams);
			this.total = res.total;
			this.list = res.rows;
			this.loading = false;
		},

		itemClick(item, index) {
			this.$router.push("/news/" + item.news_id);
		}
	}
}
</script>

<style lang="less" scoped>
.news {
	padding: 60px 40px 100px;

	>.title {
		font-size: 22px;
		color: @blackLine;
		font-weight: bold;
		margin-bottom: 50px;
	}

	.news_list {
		width: 100%;

		>li {
			width: 100%;
			height: 192px;
			display: flex;
			overflow: hidden;
			margin-bottom: 30px;
			cursor: pointer;
		}

		>li:last-of-type {
			margin-bottom: 0;
		}

		.left {
			flex-shrink: 0;
			width: 320px;
			height: 100%;
			margin-right: 30px;
			overflow: hidden;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				transition: all .3s;
			}

			img:hover {
				transform: scale(1.2);
			}
		}

		.right {
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.top {
				width: 100%;
				height: 100%;
				overflow: hidden;

				.title {
					font-size: 20px;
					color: @black;
					line-height: 1.8;
				}

				.text {
					color: @gray;
					line-height: 1.6;
					.ellipsis2;
					margin-top: 5px;
				}
			}

			.bottom {
				flex-shrink: 0;
				margin-top: 10px;
				font-size: 14px;
				color: @red;
			}
		}
	}
}
</style>
